// @flow

import getAppliedValues from './get-applied-values';

export const adaptGeneric = (facet: Facet, optionsModifier?: function): FacetWithApplied => {
  const outOptionsWithInvalidName = option => !!option.name;

  const withIsActive = option => ({
    ...option,
    value: option.name,
    isActive: 'true',
  });

  const options = facet
    .options
    .filter(outOptionsWithInvalidName)
    .map(withIsActive)
    .map(optionsModifier || (option => option));

  return {
    facet: {...facet, options},
    appliedValues: getAppliedValues(options),
  };
};
